export default "<p>legend works!</p>\n"